/* tslint:disable */
/* eslint-disable */
/**
 * WAG TP Request API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WAGTPResponseHeader
 */
export interface WAGTPResponseHeader {
    /**
     * 
     * @type {string}
     * @memberof WAGTPResponseHeader
     */
    messageId: string;
    /**
     * 
     * @type {string}
     * @memberof WAGTPResponseHeader
     */
    timestamp: string;
}

export function WAGTPResponseHeaderFromJSON(json: any): WAGTPResponseHeader {
    return WAGTPResponseHeaderFromJSONTyped(json, false);
}

export function WAGTPResponseHeaderFromJSONTyped(json: any, ignoreDiscriminator: boolean): WAGTPResponseHeader {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'messageId': json['messageId'],
        'timestamp': json['timestamp'],
    };
}

export function WAGTPResponseHeaderToJSON(value?: WAGTPResponseHeader | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'messageId': value.messageId,
        'timestamp': value.timestamp,
    };
}


